import { MdrCompaniesGridView } from '../view/MdrCompaniesGridView';
import { templateMdrCompaniesGrid } from '../view/template';
import { MdrCompaniesGridRepository } from '../repository/MdrCompaniesGridRepository';
import { BaseWebComponentController, IListenerConfig } from '../../../framework/BaseWebComponentController';
import { MdrCompaniesGridWebComponent } from '../index';
import { MdrCompaniesGridWebComponentSchema } from '../types';
import { showErrorToast } from '@nirvana/shared/common';
import { translateFn } from '../../../utils/translator.helper';
import { GridEvents } from '../../../grid/types/common';

export class MdrCompaniesGridController extends BaseWebComponentController {
  public component: MdrCompaniesGridWebComponent;
  public dataRepository: MdrCompaniesGridRepository;
  public view: MdrCompaniesGridView;
  public viewConstructor: typeof MdrCompaniesGridView;
  public dataRepositoryConstructor: typeof MdrCompaniesGridRepository;

  constructor(component: MdrCompaniesGridWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: MdrCompaniesGridView,
      viewTemplate: templateMdrCompaniesGrid,
      dataRepositoryConstructor: MdrCompaniesGridRepository,
    });
  }

  computeEventListeners(): IListenerConfig[] {
    return [
      {
        element: this.view.dom.$openConsoleButton,
        event: 'click',
        callback: this.handleOpenMdrConsole,
      },
      {
        element: this.view.dom.$wrapper,
        event: GridEvents.REFRESH_DATA_FROM_FOOTER,
        callback: async () => {
          const ssoAvailability = await this.dataRepository.dataProvider.getSsoAvailability();
          this.view.setSso(ssoAvailability);
        }
      },
    ];
  }

  async getDataForView(): Promise<MdrCompaniesGridWebComponentSchema> {
    return this.dataRepository.getDataForView();
  }

  private async handleOpenMdrConsole() {
    try {
      await this.openMdrConsoleForCurrentUser();
    } catch (error) {
      showErrorToast(error);
    }
  }

  private async openMdrConsoleForCurrentUser(): Promise<void> {
    const errorMessage = translateFn('Unexpected error occurred while opening the MDR console.');
    let response;

    try {
      response = await this.dependencies.api.clients.Mdr.openConsole().toPromise();
    } catch (error) {
      throw new Error(errorMessage);
    }

    if (!response || !response.success) {
      throw new Error(errorMessage);
    }
  }
}
